import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { BillingService } from 'src/app/core/services/billing';
import { BillingSummary } from 'src/app/models/billing-summary.model';
import { CurrentBill } from 'src/app/models/current-bill.model';
import { Invoice } from 'src/app/models/invoice.model';
import { Payment } from 'src/app/models/payment.model';
import * as fromStore from 'src/app/store/';

@Component({
  selector: 'app-billing-page',
  templateUrl: './billing-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BillingPageComponent {
  private readonly store = inject(Store);
  private readonly billingService = inject(BillingService);

  readonly payments = toSignal(this.store.select(fromStore.getAllPayments), {
    initialValue: [] as Payment[],
  });
  readonly isPaymentsLoading = toSignal(
    this.store.select(fromStore.getPaymentsLoading),
    { initialValue: false },
  );
  readonly isPaymentsLoaded = toSignal(
    this.store.select(fromStore.getPaymentsLoaded),
    { initialValue: false },
  );

  readonly invoices = toSignal(this.store.select(fromStore.getAllInvoices), {
    initialValue: [] as Invoice[],
  });
  readonly isInvoicesLoading = toSignal(
    this.store.select(fromStore.getInvoicesLoading),
    { initialValue: true },
  );

  readonly summary = toSignal(
    this.billingService.getSummary().pipe(catchError(() => of(null))),
    { initialValue: null as BillingSummary | null },
  );
  readonly currentBill = toSignal(
    this.billingService.getCurrentBill().pipe(catchError(() => of(null))),
    { initialValue: null as CurrentBill | null },
  );

}
